import { useReducer, useMemo } from 'react';

const getInitialParams = (): Params => {
  const userData = JSON.parse(localStorage.getItem('userData') || '{}');
  const storeId = userData?.userDetails?.storeId || undefined;
  const merchantId = userData?.userId || undefined;

  return {
    sortBy: 'createdAt',
    sortOrder: 'asc',
    page: 1,
    limit: 10,
    search: undefined,
    storeId,
    addedByFilter: 'All',
    statusFilter: 'All',
    merchantId,
  };
};

type Params = {
  sortBy: string;
  sortOrder: 'asc' | 'desc';
  page: number;
  limit: number;
  search?: string;
  storeId: string | undefined;
  addedByFilter: string;
  statusFilter: string;
  merchantId: string | undefined;
};

type Action =
  | { type: 'SET_SEARCH'; payload: string | undefined }
  | { type: 'SET_PAGE'; payload: number }
  | { type: 'SET_LIMIT'; payload: number }
  | { type: 'SET_SORT'; payload: { sortBy: string; sortOrder: 'asc' | 'desc' } }
  | { type: 'RESET' }
  | { type: 'SET_MERCHANT_ID'; payload: string | undefined }
  // | { type: 'SET_STORE_ID'; payload: string | undefined };

function reducer(state: Params, action: Action): Params {
  switch (action.type) {
    case 'SET_SEARCH':
      return { ...state, search: action.payload, page: 1 };
    case 'SET_PAGE':
      return state.page === action.payload ? state : { ...state, page: action.payload };
    case 'SET_LIMIT':
      return { ...state, limit: action.payload, page: 1 };
    case 'SET_SORT':
      return {
        ...state,
        sortBy: action.payload.sortBy,
        sortOrder: action.payload.sortOrder,
        page: 1,
      };
      case 'SET_MERCHANT_ID':
      return { ...state, merchantId: action.payload };
    // case 'SET_STORE_ID':
    //   return { ...state, storeId: action.payload };
    case 'RESET':
      return getInitialParams();
    
    default:
      return state;
  }
}

export function useManageCmsParams() {
  const [params, dispatch] = useReducer(reducer, getInitialParams());

  // Memoize params so the reference only changes when values actually change
  const stableParams = useMemo(() => params, [
    params.sortBy,
    params.sortOrder,
    params.page,
    params.limit,
    params.storeId,
    params.addedByFilter,
    params.statusFilter,
    params.search,
    params.merchantId,
    // params.storeId
  ]);

  return { params: stableParams, dispatch };
}
